import SessionItemView3 from './SessionItemView3';

export default SessionItemView3;
